import {serverHost} from "../../../../../../http_common.js";
import { useEffect, useReducer, useState, useRef } from "react";
import "./inventoryWorkFlows.css";
import axios from "axios";
import { useSnackbar } from "notistack";
import * as Action from "../../../../../../store/redux/terminal_reducer.js";
import { useDispatch, useSelector } from "react-redux";
// Sounds
import SuccessSound from "../../sounds/sold.wav";
import ErrorSound from "../../sounds/error.wav";
//
import Imgs from "../../images/Udupss_girl.png";
import OnholdTransactions from "../OnholdTransactions";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CallIcon from "@mui/icons-material/Call";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { isDraft } from "@reduxjs/toolkit";
import IsLoading from "../../../../../../IsLoading.jsx";


export function OnHold({ salesPayload, handleOnHold,   id, onCancel  }) {
  const [note, setNote] = useReducer((state, payload) => {
    return ({ ...state, ...payload }, { note: "" });
  });
    const {
    cart,
    discount,
    customerName,
    setLoading,
    secondaryFunction,
    setAlert,
    subTotal,
    tax,
    total
  } = salesPayload;

  return (
    <div
      className="putOnHoldCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="putOnHoldhead fx-ac spacem fx-jc">
        <p>Hold Transaction</p>
      </div>
      <div className="putOnHoldDisc fx-cl">
        <div className="putOnHoldRow ">
          <div className="fx-ac spacem">
            <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
          </div>
          <p>{cart?.length} items</p>
        </div>
        <div className="putOnHoldRow ">
          <div className="fx-ac spacem">
            <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
          </div>
          <p>
            <strong>
              ₦{" "}
              {total.toLocaleString()}
            </strong>
          </p>
        </div>
        <div className="putOnHoldRow">
          <div className="fx-ac spacem">
            <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
            <span>Discount:</span>
          </div>
          <p>None</p>
        </div>
        <div className="putOnHoldRow ">
          <div className="fx-ac spacem">
            <AccountCircleRoundedIcon fontSize="large" /> <span>Customer:</span>
          </div>
          <p>{customerName}</p>
        </div>
      </div>
      <div className="putOnHoldButtom fx-cl space2 fx-jc">
        <div className="fx-ac">
          <textarea
            name=""
            id=""
            cols="3"
            placeholder="This support grant is desgined eligible applicants."
            onChange={(x) => setNote({ note: x.target.value })}
          ></textarea>
        </div>

        <div className="fx-ac space3 fx-js">
          <button 
          style={{backgroundColor: "#f85a38", color: "#fff"}}
            onClick={onCancel}
          >
           Cancel
          </button> 
          <button
            onClick={() => {
              handleOnHold(note?.note, id);
            }}
          >
            Put On-hold
          </button>
        </div>
      </div>
    </div>
  );
}
export function AddNewProduct({ handleOnHold }) {
  return (
    <div
      className="OpBtnCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <h3>Are you sure you want to prospond this selling?</h3>
      <p>You are about to temporarily save this transaction</p>
      <div className="fx-ac space3 fx-jb">
        <button>Cancel</button>
        <button
          onClick={() => {
            handleOnHold();
          }}
        >
          Prospond
        </button>
      </div>
    </div>
  );
}
export function ClearCart({ clearCart, cart, customer, setOpenModal }) {
  const [cashCollected, setCashCollected] = useState(0);
  const grandTotal = cart?.reduce(
    (sum, item) => sum + item.pricing.sellingPrice * item.soldQuantity,
    0,
  );
  return (
    <div
      className="workflowDisplayCont clearCartCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="fx-cl space2">
        <div className="clearCarthead fx-ac fx-jc">
          <figure>&nbsp;</figure>
          <p>Are you sure?</p>
          <figure>&nbsp;</figure>
        </div>
        <div className="clearCartDiscCont ">
          <div className="clearCartDisc fx-cl">
            <div className="clearCartRow">
              <div className="fx-ac spacem">
                <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
                <span>Customer:</span>
              </div>
              <p> {customer.toLocaleString()}</p>
            </div>
            <div className="clearCartRow ">
              <div className="fx-ac spacem">
                <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
              </div>
              <p>{cart?.length} items</p>
            </div>
            <div className="clearCartRow ">
              <div className="fx-ac spacem">
                <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
              </div>
              <p>
                <strong>₦ {grandTotal.toLocaleString()}</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="clearCartButtom fx-cl space2 fx-ac">
          <p>
            Are you sure you want to delete this transaction? All associated
            records for this transaction will be permanently removed.
          </p>

          <div className="fx-ac space3 fx-jc">
            <button
              onClick={() => {
                setOpenModal(false);
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                clearCart();
              }}
            >
              Clear all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export function SaveDraft({salesPayload}){
 const {cart,discount,customerName,setLoading,secondaryFunction,setAlert,subTotal,tax,total}=salesPayload;const {enqueueSnackbar}=useSnackbar();const register=useSelector(state=>state.terminalActions?.registerData),company=salesPayload.companyData;
 const recordId=useRef(`DRAFT-${window.crypto.randomUUID()}`),pending=useRef(false);
 async function saveDraft(){if(pending.current)return;if(!company?.clientId||!register?.inventory?.inventoryId){setAlert({type:'error',message:'Open a company inventory register before saving.'});return;}pending.current=true;setLoading(true);try{const response=await axios.post(`${serverHost}/client/${encodeURIComponent(company.clientId)}/point_of_sales/save_draft`,{clientId:company.clientId,draftId:recordId.current,inventoryId:register.inventory.inventoryId,items:cart,customerId:salesPayload.customerId==='EDK323K3J2'?'':salesPayload.customerId,customer_name:customerName,totals:{discount:typeof discount==='object'?discount:0,taxAmount:tax||0}});if(![200,201].includes(response.data.status))throw new Error(response.data.message);setAlert({type:'success',message:response.data.message});enqueueSnackbar(response.data.message,{variant:'success'});secondaryFunction?.();}catch(error){setAlert({type:'error',message:error.response?.data?.message||error.message});}finally{pending.current=false;setLoading(false);}}
 return (
   <div
  className="saveDraftCard  fx-cl space2"
  onClick={(e) => e.stopPropagation()}
>
  <main>
    <div className="fx-cl space2">
      <h3 className="fs6 fw300">Save This Transaction as a Draft?</h3>

      <div className="fx-cl spacem">
        <p>
          This transaction will be saved as a draft, allowing you to continue,
          review, and complete it later without finalizing the sale.
        </p>

        <p>
          Saving as a draft will not update inventory, process any payment, or
          generate a completed sales receipt until the transaction is finalized.
        </p>
      </div>
    </div>

    <div
      className="cashPaymentDisc fx-cl"
      style={{
        padding: "0 3rem",
        width: "37rem",
      }}
    >
      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <ShoppingCartIcon fontSize="large" />
          <span>Products:</span>
        </div>
        <p>{cart?.length} items</p>
      </div>

      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <EventRoundedIcon fontSize="large" />
          <span>Grand Total:</span>
        </div>
        <p>
          <strong>₦ {total.toLocaleString()}</strong>
        </p>
      </div>

      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <WorkspacePremiumRoundedIcon fontSize="large" />
          <span>Discount:</span>
        </div>
        <p>₦ {discount?.amount || 0.0}</p>
      </div>

      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <AccountCircleRoundedIcon fontSize="large" />
          <span>Customer:</span>
        </div>
        <p style={{ color: "#fff", fontWeight: "bold" }}>
          {customerName}
        </p>
      </div>
    </div>
  </main>

  <div className="fx-ac fx-jb space3">
    <input
      type="text"
      className="saveDraftDiscription"
      placeholder="Draft description..."
    />

    <button className="animatedBtnShine" onClick={() => saveDraft()}>
      Save Draft
    </button>
  </div>
</div>
  );
 }
export function Quotation({salesPayload}){
 const {cart,discount,customerName,setLoading,secondaryFunction,setAlert,subTotal,tax,total}=salesPayload;const {enqueueSnackbar}=useSnackbar();const register=useSelector(state=>state.terminalActions?.registerData),company=salesPayload.companyData;
 const recordId=useRef(`QUOTATION-${window.crypto.randomUUID()}`),pending=useRef(false);
 async function saveQuotation(){if(pending.current)return;if(!company?.clientId||!register?.inventory?.inventoryId){setAlert({type:'error',message:'Open a company inventory register before saving.'});return;}pending.current=true;setLoading(true);try{const response=await axios.post(`${serverHost}/client/${encodeURIComponent(company.clientId)}/point_of_sales/quotation`,{clientId:company.clientId,quoteId:recordId.current,inventoryId:register.inventory.inventoryId,quoteItems:cart,customerId:salesPayload.customerId==='EDK323K3J2'?'':salesPayload.customerId,customer_name:customerName,totals:{discount:typeof discount==='object'?discount:0,taxAmount:tax||0}});if(![200,201].includes(response.data.status))throw new Error(response.data.message);setAlert({type:'success',message:response.data.message});enqueueSnackbar(response.data.message,{variant:'success'});secondaryFunction?.();}catch(error){setAlert({type:'error',message:error.response?.data?.message||error.message});}finally{pending.current=false;setLoading(false);}}
 return ( 
        <div className="saveQuotsCard fx-cl space2"onClick={(e) => e.stopPropagation()}>
          <main>
            <div className="fx-cl space2">
    <h3 className="fs6 fw300">Save This Transaction as a Quotation?</h3>
    <div className="fx-cl spacem">
      <p>
     This transaction will be saved as a quotation, allowing you to review,
  edit, and complete the sale later without processing payment or updating
  inventory.
    </p> 
    <p>note that this process will not updating
  inventory or precessed any payments.
    </p> 
    </div>
  </div>
          <div className="cashPaymentDisc fx-cl" style={{
    padding: '0 3rem',
    width: '37rem',
  }}
  >
            <div className="cashPaymentRow">
              <div className="fx-ac spacem">
                <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
              </div>
              <p>{cart?.length} items</p>
            </div>
            <div className="cashPaymentRow">
              <div className="fx-ac spacem">
                <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
              </div>
              <p>
                <strong>₦ {total.toLocaleString()}</strong>
              </p>
            </div>
            <div className="cashPaymentRow">
              <div className="fx-ac spacem">
                <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
                <span>Discount:</span>
              </div>
              <p> ₦ {discount?.amount || 0.00} </p>
            </div>
            <div className="cashPaymentRow ">
              <div className="fx-ac spacem">
                <AccountCircleRoundedIcon fontSize="large" /> <span>Customer:</span>
              </div>
              <p style={{ color: "#fff", fontWeight: "bold" }}>
                {customerName}
                   
              </p>
            </div>
          </div>
          </main>
          <div className="fx-ac fx-jb space3">
            <input type="text" className="saveQuotsDiscription" placeholder="Description.."/>
            <button className="animatedBtnShine" onClick={() =>saveQuotation()}>Save Quoatation</button>
          </div>
        </div>
     
  );
 }
export function Discount({ cart, setOpenModal }) {
  const dispatch = useDispatch();
  const [discountInPercent, setDiscountInPercent] = useState(false);
  const [discountAmount, setDiscountAmount] = useState("");

  const actualPrice = cart.reduce(
    (sum, item) => sum + item.pricing.sellingPrice * item.soldQuantity,
    0,
  );

  const discount = () => {
    if (discountInPercent) {
      return (actualPrice * discountAmount) / 100;
    } else {
      return Number(discountAmount);
    }
  };

  const estimate = actualPrice - discount();

  function handleDiscount() {
    dispatch(
      Action.dispatchDiscount({
        amount: discount(),
        type: discountInPercent ? "percentage" : "fixed",
        description: "",
      }),
    );
    setOpenModal(false);
  }

  return (
    <div
      className="discountCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <span>Enter amount below</span>
      <div className="discountInputCont fx-jb">
        <h2 className="fx-cl space1">
          <button
            className={`${!discountInPercent && "active"}`}
            onClick={() => {
              setDiscountInPercent(false);
              setDiscountAmount("");
            }}
          >
            ₦
          </button>
          <button
            className={`${discountInPercent && "active"}`}
            onClick={() => {
              setDiscountInPercent(true);
              setDiscountAmount("");
            }}
          >
            %
          </button>
        </h2>
        <input
          type="number"
          name="discount"
          id="discountInput"
          placeholder={discountInPercent ? "%" : "₦"}
          value={discountAmount}
          min={discountInPercent ? 0 : 1}
          max={discountInPercent ? 100 : actualPrice}
          onChange={(e) => {
            const value = e.target.value;

            // Allow clearing the input
            if (value === "") {
              setDiscountAmount("");
              return;
            }

            const num = Number(value);

            if (discountInPercent) {
              if (num >= 0 && num <= 100) {
                setDiscountAmount(value);
              }
            } else {
              if (num >= 1 && num <= actualPrice) {
                setDiscountAmount(value);
              }
            }
          }}
        />
      </div>
      <div className="fx-cl">
        <div className="fx-cl spacem">
          <div className="discountBar fx-ac fx-jb space2">
            <div className="disBarMdl fx-ac fx-jc">
              <AccountCircleRoundedIcon />
            </div>
            <div className="disBarTop">&nbsp;</div>

            <div className="fx-ac spacem">
              <figure>
                <AccountCircleRoundedIcon />
              </figure>
              <span>Actual</span>
            </div>
            <span> ₦ {actualPrice.toLocaleString()}</span>
          </div>
          <div className="fx-cl space1">
            <div className="discountBar fx-ac fx-jb space2">
              <div className="disBarBtm">&nbsp;</div>
              <div className="fx-ac spacem">
                <figure>
                  <EventRoundedIcon />
                </figure>
                <span>Discount</span>
              </div>
              <span>
                {" "}
                ₦{" "}
                {discountInPercent
                  ? discount().toLocaleString()
                  : discountAmount.toLocaleString()}{" "}
              </span>
            </div>
          </div>
        </div>
        <div className=" discountEstimation fx-ac space2 fx-jb">
          <span>Estimated fee</span>
          <span>
            <strong> ₦ {estimate.toLocaleString()} </strong>
          </span>
        </div>
      </div>
      <div className="discountSubmit fx-ac">
        <button
          className="confirmDiscountBtn"
          onClick={() => {
            if (Number(discountAmount) > 0) {
              handleDiscount();
            }
          }}
          style={{
            cursor: Number(discountAmount) > 0 ? "pointer" : "not-allowed",
            backgroundColor: Number(discountAmount) > 0 ? "#3a84f8" : "#ededed",
            color: Number(discountAmount) > 0 ? "#fff" : "#444",
            opacity: Number(discountAmount) > 0 ? 1 : 0.6,
            fontFamily: "cursive",
          }}
        >
          Apply Discount
        </button>
      </div>
      <div className="discountFoot fx-ac fx-jc">
        <ForumRoundedIcon /> Highly secured and encryped by Green
      </div>
    </div>
  );
}
export function HoldedSales({
  onHoldData,
  attendOnHold,
  deleteOnHold,
  moveOnHoldToDraf,
  handleHoldedSale,
}) {
  return (
    <>
      <OnholdTransactions
        onHoldData={onHoldData}
        attendOnHold={attendOnHold}
        deleteOnHold={deleteOnHold}
        moveOnHoldToDraf={moveOnHoldToDraf}
        handleHoldedSale={handleHoldedSale}
      />
    </>
  );
}
export function Contacts({ clientData, setOpenModal, contacts = [], onAdd, onSelect, onRefresh, loading = false, error = "" }) {
  const [search, setSearch] = useState("");
  const [details, setDetails] = useState(null);
  const filtered = contacts.filter((contact) => {
    const text = [contact?.profile?.fullName, contact?.contact?.phone?.primary,
      contact?.contact?.email?.primary, contact?.profile?.type].join(" ").toLowerCase();
    return text.includes(search.trim().toLowerCase());
  });
  return (
    <div className="contactWrapper fx-cl space2 pos-contact-dialog" role="dialog" aria-label="Saved contacts" onClick={(event) => event.stopPropagation()}>
      <div className="contactCont fx-cl space3">
        <header className="fx-ac fx-jb space2">
          <div className="fx-cl spacem">
            <span className="pos-eyebrow">CUSTOMER DIRECTORY</span>
            <h3 className="fs6 fw600">Contacts</h3>
            <p>{contacts.length} saved contacts · Select a customer for this sale</p>
          </div>
          <button className="btnCloseContacts fx-ac fx-jc" aria-label="Close contacts" onClick={() => setOpenModal(false)}><CloseOutlinedIcon /></button>
        </header>
        <div className="pos-contact-tools">
          <input aria-label="Search contacts" type="search" placeholder="Search by name, phone, email or type" value={search} onChange={(e) => setSearch(e.target.value)} />
          <button type="button" onClick={onRefresh} disabled={loading}>Refresh</button>
          <button type="button" className="pos-primary" onClick={onAdd}><AddOutlinedIcon fontSize="small" /> Add new</button>
        </div>
        {error && <p className="pos-inline-error" role="alert">{error}</p>}
        {loading ? <p role="status">Loading contacts…</p> : filtered.length === 0 ? (
          <div className="pos-empty-state">{search ? "No matching contacts found." : "No saved contacts yet. Add the first one."}</div>
        ) : (
          <div className="contactsItem g g3">
            {filtered.map((contact) => <figure className="theContact" key={contact.contactId || contact._id}>
              <div className="theContTop fx-cl space2">
                <div className="fx-ac fx-jb"><span>{contact?.profile?.type || "Contact"}</span><span>{contact?.profile?.status || ""}</span></div>
                <div className="contactDiscr spacem">
                  <span className="theContactImg fx-ac fx-jc fw600 fs6">{contact?.profile?.fullName?.charAt(0).toUpperCase() || "?"}</span>
                  <div className="fx-cl"><strong className="fs4">{contact?.profile?.fullName || "Unnamed contact"}</strong><span>{contact?.contact?.phone?.primary || "No phone"}</span></div>
                </div>
                <div className="fx-ac space2">
                  <button type="button" onClick={() => setDetails(contact)}><InfoOutlinedIcon fontSize="small" /> Details</button>
                  <button type="button" disabled={contact?.profile?.type?.toLowerCase() !== "customer"} onClick={() => onSelect(contact)}><AddShoppingCartOutlinedIcon fontSize="small" /> Select customer</button>
                </div>
              </div>
              <div className="theContFoot">
                <span className="fs1 fw500">{contact?.contact?.phone?.primary || "No Phone"}</span>
              </div>
            </figure>)}
          </div>
        )}
        {details && <div className="pos-contact-details" role="region" aria-label="Contact details">
          <div className="fx-ac fx-jb"><h4>{details?.profile?.fullName}</h4><button type="button" onClick={() => setDetails(null)}>Close details</button></div>
          <p>Type: {details?.profile?.type || "—"} · Status: {details?.profile?.status || "—"}</p>
          <p>Phone: {details?.contact?.phone?.primary || "—"}</p>
          <p>Email: {details?.contact?.email?.primary || "—"}</p>
          <p>Address: {[details?.contact?.address?.street, details?.contact?.address?.city].filter(Boolean).join(", ") || "—"}</p>
          <p>Notes: {details?.notes?.description || "—"}</p>
          <button type="button" disabled={details?.profile?.type?.toLowerCase() !== "customer"} onClick={() => onSelect(details)}>Use for this sale</button>
        </div>}
      </div>
    </div>
  );
}
